import React, { useContext } from 'react';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink,Image } from '@react-pdf/renderer';
import { Button, useTheme, useMediaQuery } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import { Grid, Paper, Typography, Stack, Box } from "@mui/material";
import Hubballi from "./Hubballi-Regular.ttf"
import { Font } from '@react-pdf/renderer';
import installationCondition from "./Installationconditions.json";
import deratingimages from "./Deratingimages.json"
import cabledatasheet from "./olexhvdatasheet.json"


function ReportComponent ({ results, inputData }){

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
   
  const activeResults = results?.activeResults
  const cableType = inputData?.cabletype
  const deratingcondition = inputData?.deratingConditions
  const additionalderatingcondition = inputData?.additionalderatingConditions 
  const installation = inputData?.installation
  const installationArray = installationCondition?.[cableType]?.[installation];
  const installationimage = installationArray
  const deratingconditionimage =
  deratingimages?.[cableType]?.[deratingcondition?.["Installation"]] ||
  deratingimages?.[cableType]?.[installation];  const installationOption = inputData.installation
  const deratingresults = activeResults?.Derating
  const loadcurrent = inputData?.loadCurrent
  const kvarating = inputData?.kvarating
  const deratingfactor = activeResults?.Derating?.[activeResults.Derating.length - 1]?.[1]?.[0];
  const voltage = inputData?.voltagelabel
  const activetriptime = inputData?.faulttriptime
  const supplyfaultlevelinput = inputData?.faultlevel
  const datasheet = cabledatasheet[inputData.conductor]?.[inputData.cabletype]?.[voltage];

  // Extracting values
  const Active_cable_size = activeResults?.selectedCableSize;
  const Active_cable_mode = inputData?.activeCableSizingMode;
  const Circuit_capacity_derated = activeResults?.currentCarryingCapacity?.circuitRatingDerated;
  const Circuit_capacity = activeResults?.currentCarryingCapacity?.circuitRating;
  const spare_capacity = Math.round(activeResults?.currentCarryingCapacity?.spareCapacity * 100) / 100;
  const number_of_active_circuits = activeResults?.number_of_circuits;
  const current_carrying_cap_ok = activeResults?.currentCarryingCapacity?.ok;
 

  const short_circuit_cap_ok = activeResults?.shortCircuitCapacity?.ok;
  const I_conductor_new = activeResults?.shortCircuitCapacity?.I_conductor_new;
  const I_screen_new = activeResults?.shortCircuitCapacity?.I_screen_new;

  Font.register({
  family: 'Hubballi',
  src: Hubballi,
});
 
const styles = StyleSheet.create({
      rowSplit: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 1,
  },
  leftTextContainer: {
    flex: 3,
    paddingRight: 10,
  },
  rightImageContainer: {
    flex: 1,
    alignItems: 'flex-end',
  },
  page: {
    padding: 40,
    fontFamily: 'Hubballi',
    backgroundColor: '#ffffff',
  },
  headingContainer: {
    marginBottom: 20,
    textAlign: 'center',
  },
  heading: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'left',
    color: '#333333',
    paddingBottom: 10,
    fontFamily: 'Hubballi',
  },
  section: {
    marginTop: 2,
    paddingBottom: 10,
    paddingTop: 10,
 
    borderTopWidth: 1,
    borderTopColor: '#ccc',

  },
  subheading: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 10,
    marginTop: 10
  },
  bodyText: {
    fontSize: 12,
    color: '#333',
    lineHeight: 1.4,
  },
    image: {
    width: 80,
    height: 80,
  },
      image1: {
    width: 500,
    height: 650,
  },
});
 
 
 
 const MyDocument = () => (
  <Document>
    <Page size="A4" style={styles.page}>
            <View style={styles.headingContainer}>
              <Text style={styles.heading}>
                HV CABLE SIZE CALCULATION REPORT
              </Text>
                            <Text style={styles.heading}>
               (BASED ON MANUFACTURER DATASHEET)
              </Text>
            </View>

            <Text style={styles.subheading}>CABLE SIZE</Text>
          <View style={styles.section}>
                    
          <Text style={styles.bodyText}>
                      Active Cable Size = {number_of_active_circuits} x {Active_cable_size} mm², Cable Type: {inputData.conductor} / {inputData.voltagelabel} kV / {inputData.cabletype} 
                    </Text>
          </View>
<Text style={styles.subheading}>INSTALLATION CONDITIONS</Text>
            <View style={styles.section}>
        
        <Text style={styles.bodyText}>
          Load Current = {loadcurrent} A ({kvarating} kVA)
        </Text>
        <Text style={styles.bodyText}>
        Supply: {voltage} kV
        </Text>
        <View style={styles.rowSplit}>
        <View style={styles.leftTextContainer}>
            <Text style={styles.bodyText}>
            Installation Method : {installation} 
            </Text>
        </View>
        <View style={styles.rightImageContainer}>
            <Image style={styles.image} src={installationimage} />
        </View>
        </View>

                <View style={styles.rowSplit}>
        <View style={styles.leftTextContainer}>
         {Object.entries(deratingcondition).map(([key, value], index) => (
    <Text key={index} style={styles.bodyText}>
      {key}: {value}
    </Text>
  ))}
            {Object.entries(additionalderatingcondition).map(([key, value], index) => (
    <Text key={index} style={styles.bodyText}>
      {key}: {value}
    </Text>
  ))}
        </View>
            {deratingconditionimage && (
            <View style={styles.rightImageContainer}>
                <Image style={styles.image} src={deratingconditionimage} />
            </View>
            )}
        </View>


        <Text style={styles.subheading}>CURRENT CARRYING CAPACITY {current_carrying_cap_ok ? '(PASS)' : '(FAIL)'}</Text>
        
            <View style={styles.section}>
        
        <Text style={styles.bodyText}>
          Current Carrying Capacity = {Circuit_capacity} A 
          </Text>
          <Text style={styles.bodyText}>
          Current Carrying Capacity (Derated) = {Circuit_capacity_derated} A
          </Text>
          <Text style={styles.bodyText}>
          Spare Capacity = {spare_capacity} A 
          </Text>
        <Text style={styles.bodyText}>
        </Text>
      </View>


              <Text style={styles.subheading}>DERATING CONDITIONS</Text>
        
            <View style={styles.section}>
        
{Array.isArray(deratingresults) && deratingresults.map((value, index) => (
  <Text key={index} style={styles.bodyText}>
    {value[0]}: {value[1][0]}, (Reference: {value[1][1]})
  </Text>
))}
      </View>


                 <Text style={styles.subheading}> SHORT CIRCUIT TEMPERATURE RISE {short_circuit_cap_ok ? '(PASS)' : '(FAIL)'}</Text>
              
                  <View style={styles.section}>
              
              <Text style={styles.bodyText}>
                  Supply Fault Level: {supplyfaultlevelinput} A for {activetriptime} s
                </Text>
              <Text style={styles.bodyText}>
                Conductor Short Circuit Capacity Rating : {I_conductor_new} A for {activetriptime} s
                </Text>
              <Text style={styles.bodyText}>
                Screen Short Circuit Capacity Rating : {I_screen_new} A for {activetriptime} s
                </Text>
            </View>
            </View>

            </Page>

            <Page size="A4" style={styles.page}>

                 <Text style={styles.subheading}> CABLE DATASHEET </Text>
              
                  <View style={styles.section}>
<Image style={styles.image1} src={datasheet} />
            </View>

      

    </Page>
   
  </Document>
);


      
      return (

<PDFDownloadLink
  document={<MyDocument/>}
  fileName="Cable Report.pdf"
>
  {({ blob, url, loading, error }) =>
    error|loading ? (
      <Button
        variant="contained"
        color="primary"
        disabled
        startIcon={<DescriptionIcon />}
        sx={{
          borderRadius: "12px",
          fontFamily: "'Hubballi', sans-serif",
          fontSize: "1.1rem",
          padding: "0.6rem 1.2rem",
          textTransform: "none",
        }}
      >
        Loading document...
      </Button>
    ) : (

          <Button
      variant="contained"
      color="primary"
      // Only set the startIcon prop on non-mobile screens
      startIcon={!isMobile ? <DescriptionIcon /> : null}
      sx={{
        borderRadius: "12px",
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "1.1rem",
        textTransform: "none",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        // Style adjustments for the mobile icon-only button
        ...(isMobile && {
          minWidth: 'auto', // Allow the button to shrink to the icon's size
          padding: '0.6rem', // Apply equal padding
        }),
        // Original padding for the desktop button
        ...(!isMobile && {
          padding: "0.3rem 1.2rem",
        }),
      }}
    >
      {/* Conditionally render the icon for mobile or the text for desktop */}
      {isMobile ? <DescriptionIcon /> : "Download Report"}
    </Button>
    )
  }
</PDFDownloadLink>

    );

}

export default ReportComponent;


